import script from "./SupportCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportCard.vue?vue&type=script&setup=true&lang=ts"

import "./SupportCard.vue?vue&type=style&index=0&id=285572a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285572a0"]])

export default __exports__